import _ from 'underscore';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { DateInlineEditView } from './date-inline-edit-view';

export function DateInlineEditableColumnPrompt({
  position,
  isForVNext,
  item,
  allowNoDate,
  selectedDate,
  minDate,
  maxDate,
  view,
  i18n,
  fieldName,
  customClass = 'grid-group-other',
  updater = null,
}) {
  const dateEditorView = new DateInlineEditView({
    minDate,
    maxDate,
    allowNoDate,
    selectedDate,
    i18n,
    fieldName,
  });

  dateEditorView.on('save', ({ newSelectedDate }) => {
    const updated = _.extendOwn({}, item);

    updated[fieldName] = newSelectedDate ?
      newSelectedDate.toISOString() :
      newSelectedDate;

    if (view && view.instrumentation) {
      const sn = view.instrumentation.datepicker;
      const adsActivity = sn && sn.create().inlineDateChange.create();
      if (adsActivity && adsActivity.signal) {
        adsActivity.signal(`${fieldName} date changed: ${newSelectedDate}`);
      }
    }

    return updater({
      view,
      i18n,
      fieldName,
      updated,
      editorView: dateEditorView,
      editorViewCallbackAfterUpdate: () => {
        dateEditorView.trigger('close');
      },
      isDateType: true,
    });
  });

  const editorView = new GridCustomizedPopupEditor({
    editorView: dateEditorView.render(),
    cellPosition: position,
    renderBelow: false,
    className: `adgroup-grid-inline-edit-popup grid-popupeditor ${customClass}`,
    parentContainerSelector: isForVNext ? '.grid-and-disclaim-container' : null,
  });

  return editorView.render();
}
